import { useCallback, useEffect, useRef } from 'react';
import scrollToElement, {
  REPOSITION_DELAYS
} from '~/utilities/vdp/scrollToElement';

export default function useRepositionScheduler() {
  const repositionTimeoutsRef = useRef<number[]>([]);
  const shouldRepositionRef = useRef(false);

  const clearRepositions = useCallback(() => {
    repositionTimeoutsRef.current.forEach(timeout => clearTimeout(timeout));
    repositionTimeoutsRef.current = [];
    shouldRepositionRef.current = false;
  }, []);

  const scheduleRepositions = useCallback(
    (sectionId: string) => {
      clearRepositions();
      shouldRepositionRef.current = true;

      REPOSITION_DELAYS.forEach(delay => {
        const timeout = window.setTimeout(() => {
          if (shouldRepositionRef.current) {
            scrollToElement(sectionId);
          }
        }, delay);
        repositionTimeoutsRef.current.push(timeout);
      });
    },
    [clearRepositions]
  );

  useEffect(() => {
    return () => clearRepositions();
  }, [clearRepositions]);

  return { clearRepositions, scheduleRepositions };
}
